/**
 * authKeys — the browser-storage names of the login's lifecycle notes.
 *
 * VH-284: why the last login ended, for the note on the login page. Kept in
 * localStorage so every tab that follows the log-out shows it too.
 * VH-293: "expired" when the server refused the login, and whose login it was
 * (written at every login, removed only by a chosen log-out), so the report
 * page can tell "your login ended" from "never logged in here".
 *
 * A module of their own (re-exported by services/api) so the pages that read
 * them do not depend on the whole API client.
 */
export const LOGOUT_REASON_KEY = 'logout_reason'
export const LOGOUT_REASON_IDLE = 'idle'
export const LOGOUT_REASON_EXPIRED = 'expired'
export const LOGIN_USER_KEY = 'login_user_id'
